module.exports = __webpack_public_path__ + "img/on_location_25.8ada114c.png";